import axios from "axios";
const moment = require('moment-timezone');
export default {
  install(Vue, store) {

    const helpers = new Helpers();
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
}

class Helpers {
  constructor() {
  }


  formatDateStringTZ(datestr, format=null){
    /*if(format != null){
      if (this.store.state.storeSettings.timeZone) {
        if (!this.isBlank(datestr)) {
          return moment.tz(datestr, this.store.state.storeSettings.timeZone).locale('de').format(format);
        } else {
          return moment(datestr).format(format).locale('de');
        }
      }
    }*/
    return this.convertDateStringTZ(datestr);
  }

  convertDateString(datestr) {
    if (!this.isBlank(datestr)) {
      return moment(datestr).format('YYYY-MM-DDTHH:mmZ');
    } else {
      return null;
    }
  }

  convertDateStringUTC(datestr) {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format('YYYY-MM-DDTHH:mmZ');
    } else {
      return null;
    }
  }

  convertDateStringTZ(datestr) {
    /*if (this.store.state.storeSettings.timeZone) {
      if (!this.isBlank(datestr)) {
        return moment.tz(datestr, this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
      } else {
        return null;
      }
    }*/
    return this.convertDateString(datestr);

  }

  convertDateTimeString(datestr, timestr) {

    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment(datestr + 'T' + timestr).format('YYYY-MM-DDTHH:mmZ');
    } else if (!this.isBlank(datestr)) {
      return moment(datestr + 'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
    } else if (!this.isBlank(timestr)) {
      return moment(timestr, 'HH:mm').format('HH:mmZ');
    } else {
      return null;
    }
  }

  convertDateTimeStringUTC(datestr, timestr) {

    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment.utc(datestr + 'T' + timestr).format('YYYY-MM-DDTHH:mmZ');
    } else if (!this.isBlank(datestr)) {
      return moment.utc(datestr + 'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
    } else if (!this.isBlank(timestr)) {
      return moment.utc(timestr, 'HH:mm').format('HH:mmZ');
    } else {
      return null;
    }
  }

  convertDateTimeStringTZ(datestr, timestr) {
    /*if (this.store.state.storeSettings.timeZone) {
      if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
        return moment.tz(datestr + 'T' + timestr, this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
      } else if (!this.isBlank(datestr)) {
        return moment.tz(datestr + 'T00:00:00', this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
      } else if (!this.isBlank(timestr)) {
        return moment.tz("2019-11-01T" + timestr, this.store.state.storeSettings.timeZone).format('HH:mmZ');
      } else {
        return null;
      }
    }*/
    return this.convertDateTimeString(datestr, timestr);
  }

  extractDateStringTZ(datestr, format = "YYYY-MM-DD") {
    /*if (this.store.state.storeSettings.timeZone) {
      if (!this.isBlank(datestr)) {
        return moment.tz(datestr, this.store.state.storeSettings.timeZone).format(format);
      } else {
        return null;
      }
    }*/
    return this.extractDateString(datestr, format);


  }

  extractTimeStringTZ(str, format = "HH:mm") {
    /*if (this.store.state.storeSettings.timeZone) {
      if (!this.isBlank(str)) {
        return moment.tz(str, 'HH:mmZ', this.store.state.storeSettings.timeZone).format(format);
      } else {
        return null;
      }
    }*/
    return this.extractTimeString(datestr, format);
  }

  extractDateString(datestr, format = "YYYY-MM-DD") {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format(format);
    } else {
      return null;
    }

  }

  extractTimeString(str, format = "HH:mm") {
    if (!this.isBlank(str)) {
      return moment.utc(str, 'HH:mmZ').format(format);
    } else {
      return null;
    }

  }

  getNowDateTimeString(format = "DD.MM.YYYY HH:mm") {
    return this.getMomentTZ().format(format);
  }

  getWeekDays() {
    return moment.weekdays();
  }
  getActualMoment(param = null) {
    if (param) {
      return moment(param).locale('de');
    }
    return moment;
  }
  getMoment() {
    return moment().locale('de');
  }

  getMomentUTC() {
    return moment.utc().locale('de');
  }

  getMomentTZ() {
    /*if (this.store.state.storeSettings.timeZone) {
      //console.log("timezone");
      return moment.tz(this.store.state.storeSettings.timeZone).locale('de');
    }*/
    return this.getMoment();
  }

  getMomentTZStartOfDay() {
    return this.getMomentTZ().hours(0).minutes(0).seconds(0).milliseconds(0);
  }

  getMomentFromString(str, format = 'YYYY-MM-DDTHH:mmZ') {
    return moment(str, format).locale('de');
  }

  getMomentFromStringUTC(str, format = 'YYYY-MM-DDTHH:mmZ') {
    return moment.utc(str, format).locale('de');
  }

  getMomentFromStringTZ(str, format = 'YYYY-MM-DDTHH:mmZ') {
    /*if (this.store.state.storeSettings.timeZone) {
      return moment.tz(str, format, this.store.state.storeSettings.timeZone).locale('de');
    }*/
    return this.getMomentFromString(str, format);
  }

  getNextMonthMoment() {
    return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
  }

  getNextMonthMomentUTC() {
    return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
  }

  getNextMonthMomentTZ() {
    /*if (this.store.state.storeSettings.timeZone) {
      return moment.tz(this.store.state.storeSettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
    }*/
    return this.getNextMonthMoment();
  }

  getCurrentMoment() {
    return moment().locale('de');
  }

  getCurrentMonthMoment() {
    return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
  }

  getCurrentMonthMomentUTC() {
    return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
  }

  getCurrentMonthMomentTZ() {
    /*if (this.store.state.storeSettings.timeZone) {
      return moment.tz(this.store.state.storeSettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
    }*/
    return this.getCurrentMonthMoment();
  }

  getMomentFromUnix(unix = 0) {
    return moment.unix(unix).locale('de');
  }

  getMomentFromUnixUTC(unix = 0) {
    return moment.utc().unix(unix).locale('de');
  }

  getMomentFromValues(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    return moment().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
  }

  getMomentFromValuesUTC(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    return moment.utc().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
  }

  getMomentFromValuesTZ(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    /*if (this.store.state.storeSettings.timeZone) {
      return moment.tz(this.store.state.storeSettings.timeZone).year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
    }*/
    return this.getMomentFromValues(year, month, day, hours, minutes, seconds, milliseconds);
  }

  getMomentDuration(start, end) {
    return moment.duration(end.diff(start)).locale('de');
  }

  gender(code) {
    switch (code) {
      case 'M':
        return "männlich";
      case 'F':
        return "weiblich";
      default:
        return "";
    }
  }

  salutation(code) {
    switch (code) {
      case 'M':
        return "Herr";
      case 'F':
        return "Frau";
      default:
        return "";
    }
  }

  getRandomLightColor() {
    let color = this.hslToHex(Math.random() * 360, 100, 75);
    return color;
  }

  hslToHex(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = x => {
      const hex = Math.round(x * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  hexToHSLObject(H) {
    let r = 0, g = 0, b = 0;
    if (H.length === 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      delta = cmax - cmin,
      h = 0, s = 0, l = 0;

    if (delta === 0) h = 0;
    else if (cmax === r) h = ((g - b) / delta) % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return {h: h, s: s, l: l};
  }

  hexToHSL(H){
    let hsl = this.hexToHSLObject(H);
    return 'hsl(' + hsl.h + ',' + hsl.s + '%,' + hsl.l +'%)';
  }


  OpenPopup(state) {
    if(state && state.draggable && this.DragOpenedCheck()) return; //if you're already dragging a popup don't open it, it's better to put this here then on every mousedown function
    window.app.genericPopups.push(state);
    return state;
  }

  DragOpenedCheck(){
    return window.app.genericPopups.find(p => p.draggable);
  }

  ValidEmailCheck(email){
    let emailPattern = new RegExp('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])');
    return emailPattern.test(email);
  }

  OpenInfoPopup(header, descriptionLines, callbackAccept, callbackCancel) {
    let view = this;
    let entries = [];
    descriptionLines = descriptionLines.filter(l => l && l !== '');
    for(let x in descriptionLines){
      let style = {'text-align': 'left'};
      let entry = {key: 'info' + x, type: 'output', value: descriptionLines[x], dataStyles:style}
      if(x == descriptionLines.length - 1) entry.styles = {'margin-bottom': '-20px'};
      entries.push(entry);
    }
    let callbackAcceptWrapper;
    if(!callbackAccept) callbackAcceptWrapper = (entries, datafill) => {datafill.$parent.locked = false};
    else callbackAcceptWrapper = (entries, datafill) => {datafill.locked = false; callbackAccept(entries, datafill)};
    let callbackCancelWrapper = undefined;
    if(callbackCancel) callbackCancelWrapper = (entries, datafill) => {datafill.$parent.locked = false; callbackCancel(entries, datafill)};
    this.OpenPopup({
      header: header,
      width: '500px',
      components: [{
        type: 'datafill',
        state: {
          entries: entries,
          selectCallback: callbackAcceptWrapper,
          deleteCallback: callbackCancelWrapper,
          positiveButtonLabel: 'Ok',
          negativeButtonLabel: 'Abbrechen',
        },
      }],
      centered: true,
      locked: true,
    });
  }

  MountViewOnDropdownContainer(view, options){

    let state = {
      show: true,
      toggled: true,
      centered: true,
      expanded: true,
    };

    for(let o in options){
      state[o] = options[o];
    }
    let containerState = this.OpenPopup(state);
    requestAnimationFrame(function(){
      let container = window.app.$children.find(c => c.state === containerState);
      if(container){
        container.$el.querySelector('.tab-body').appendChild(view.$el);
        container.toggled = true;
        container.show = true;

        view.$once('hook:beforeDestroy', () => {
          container.locked = false;
          container.$emit('on-close', container);
          view.$destroy();
          container.$destroy();
        })
      }
    })
  }
  GetDataTableStateFromObject(dataItem, dataArray, sumArray) {

    let headerMap = {};

    for (let key in dataItem) {

      headerMap[key] = {
        key: key,
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray : [],
      dataSum: sumArray ? sumArray : [],
    }
  }
  GetDataTableStateFromKeyLabelObject(dataItem, dataArray, sumArray) {

    let headerMap = {};

    for (let key in dataItem) {

      headerMap[key] = {
        key: key,
        label: dataItem[key] && dataItem !== '' ? dataItem[key] : this.ConvertKeyToName(key),
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray : [],
      dataSum: sumArray ? sumArray : [],
    }
  }

  ConvertKeyToName(key) {
    if (key === undefined) return '';
    key = key.toString();
    let label = '';
    let temp = '';
    key.split('_').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
    label = temp;
    temp = '';
    label.split('-').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
    label = temp;
    temp = '';
    label.split(/(?=[A-Z])/).filter(l => l.length > 0).forEach(l => temp += ' ' + l);
    label = temp;
    label = label.replace(/\s\s+/g, ' ').trimRight();
    return label;
  }

  GetDataFillStateFromObject(object, selectCallback, asArray = false) {

    let dataEntries = {};
    if (asArray) {
      dataEntries = [];
    }
    for (let x in object) {
      let entry = {
        key: x,
        label: this.ConvertKeyToName(x),
        hidden: false,
        value: object[x],
        type: 'text',
      };
      if (asArray) {
        dataEntries.push(entry);
      } else {
        dataEntries[x] = entry;
      }
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback
    };
  }


  GetDataFillStateFromKeyLabelObject(object, selectCallback) {

    let dataEntries = {};
    for (let x in object) {
      dataEntries[x] = {
        key: x,
        label: object[x],
        hidden: false,
        value: null,
        type: 'text',
      };
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback
    };
  }
  OpenDatepickerPopup(dateOptions, dateEvents, popupOptions) {
    /* example datepicker
        dateOptions = {viewsEnabled: ['W','M','Y','C'], date: dateMoment}
        dateEvents = {
            OnDateSelect: (date) => {...}, //always called to avoid having to define it x5 for a generic date pick
            OnWeekSelect: (date) => {...}, //you don't have to define these or OnDateSelect if you're not using them
            OnDaySelect: (date) => {...},
            OnMonthSelect: (date) => {...},
            OnYearSelect: (date) => {...},
            OnCalendarSelect: (date) => {...},
        };
        popupOptions: {elRelative: $event.currentTarget} // if elRelative isn't defined the popup will open on the cursor so no big deal
    */
    let defaultState = {
      components: [{
        type: 'datepicker',
        state: dateOptions,
        customEvents: dateEvents,
      }],
      noScroll: true,
      pointerDirection: 3,
      elRelative: null,
      pointerOffset: 0,
      pointerHide: true,
      pinTopRight: true,
      expanded: true,
    };
    if(popupOptions) for(let x in popupOptions) defaultState[x] = popupOptions[x];

    this.OpenPopup(defaultState);

  }


}
